import { useTranslation } from 'react-i18next';

export default function SatisfactionGuarantee() {
  const { t } = useTranslation();
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-500/8 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Main card */}
        <div className="rounded-3xl border border-emerald-500/20 bg-gradient-to-b from-gray-900/90 to-gray-950 p-8 sm:p-12 text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500/20 to-transparent" />

          {/* Shield icon */}
          <div className="relative inline-flex mb-6">
            <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-4xl sm:text-5xl" />
            </div>
            <span className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-amber-400 flex items-center justify-center">
              <i className="ri-check-line text-gray-900 text-sm font-black" />
            </span>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-white">
            {t('guarantee.title')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
              {t('guarantee.title2')}
            </span>
          </h2>
          <p
            className="text-base sm:text-lg text-gray-400 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed"
            dangerouslySetInnerHTML={{ __html: t('guarantee.desc') }}
          />

          {/* 3 cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
            {[
              { icon: 'ri-money-cny-circle-line', titleKey: 'guarantee.g1_title', descKey: 'guarantee.g1_desc', color: 'from-emerald-500/20 to-teal-500/10', border: 'border-emerald-500/20', iconColor: 'text-emerald-400' },
              { icon: 'ri-calendar-check-line', titleKey: 'guarantee.g2_title', descKey: 'guarantee.g2_desc', color: 'from-amber-500/15 to-orange-500/10', border: 'border-amber-500/20', iconColor: 'text-amber-400' },
              { icon: 'ri-customer-service-2-line', titleKey: 'guarantee.g3_title', descKey: 'guarantee.g3_desc', color: 'from-[#0ea5e9]/15 to-[#38bdf8]/10', border: 'border-[#0ea5e9]/20', iconColor: 'text-[#7dd3fc]' },
            ].map(({ icon, titleKey, descKey, color, border, iconColor }) => (
              <div key={titleKey} className={`bg-gradient-to-br ${color} border ${border} rounded-2xl p-5 sm:p-6 hover:scale-[1.02] transition-all duration-300`}>
                <div className="w-12 h-12 rounded-xl bg-gray-900/60 flex items-center justify-center mx-auto mb-4">
                  <i className={`${icon} ${iconColor} text-2xl`} />
                </div>
                <h3 className="font-bold text-white mb-2 text-base">{t(titleKey)}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{t(descKey)}</p>
              </div>
            ))}
          </div>

          {/* CTA link */}
          <div className="mt-8">
            <a href="/refund" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm font-medium transition-colors cursor-pointer">
              <i className="ri-file-text-line" />
              View our full Refund Policy
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
